export default __webpack_public_path__ + "static/car_insurance-0ade99a8cc9e72befa33347d9be76508.png";